import GoogleWallet from './GoogleWallet';

export default GoogleWallet;
